import { request } from '@pb/utils'

import { UnreviewedProductsResponse } from './duck/types'
import { ReviewData } from './types'

const fetchUnreviewedProducts = async (
  userId: string,
  endpoint: string,
): Promise<UnreviewedProductsResponse | null> => {
  if (endpoint) {
    const { data } = await request.get(
      `${endpoint}?userId=${userId}&suppressUserPII=true&sort=orderDate%3Adesc`,
      {
        use: { apiVersion: false, locale: false },
      },
    )
    return data
  }
  return null
}

const createReview = async (
  review: ReviewData,
  endpoint: string,
): Promise<UnreviewedProductsResponse> => {
  return request
    .post(`${endpoint}`, {
      data: review,
      use: { apiVersion: false, locale: false },
    })
    .then((res) => res.data)
}

export default { fetchUnreviewedProducts, createReview }
